import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table } from 'antd';
import { FaSearch, FaFilter } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import styles from './serviceList.module.css'; // Assuming you're using CSS modules
import APIURL from '../api/apiClient';

const ServiceList = () => {
      const [loading, setLoading] = useState(false);
    const [serviceList, setServiceList] = useState([]);
    const [filterList, setFilterList] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 5 });
    const [filters, setFilters] = useState({
        date: '',
        category: '',
        brand: ''
    });
    const [showFilters, setShowFilters] = useState(false);

    const columns = [
        {
            title: 'S.No',
            dataIndex: 'index',
            key: 'index',
            render: (text, record, index) => {
              const pageSize = pagination.pageSize; // Get pageSize from state
              const currentPage = pagination.current || 1;
              return <div>{(currentPage - 1) * pageSize + index + 1}</div>;
            },
            width: 60,
          },
          
        {
            title: 'Service Id',
            dataIndex: 'id',
            render: (id) => {
                return (
                    <div>
                        <Link to={`/servicescreen/${id}`} style={{ textDecoration: 'none' }}>{id}</Link>
                    </div>
                );
            },
        },
        // {
        //     title: 'Name',
        //     dataIndex: 'user_name',
        // },
        {
            title: 'Service Status',
            dataIndex: 'status',
            render: (status) => (
                <div className={styles.status_cell}>
                    {status}
                </div>
            )
        },
        {
            title: 'Customer Response',
            dataIndex: 'customer_response'
        },
        {
            title: 'Product category',
            dataIndex: 'category_name',
        },
        {
            title: 'Product brand',
            dataIndex: 'brand',
        },
        {
            title: 'Product name',
            dataIndex: 'manual_product_name',
        },
       
    ];

   useEffect(() => {
  const fetchServiceList = async () => {
    setLoading(true);
    try {
      const data = await APIURL.get('/fetchservicelist.php');

      // ✅ Ensure it’s parsed and an array
      const parsedData = Array.isArray(data)
        ? data
        : (() => {
            try {
              const json = JSON.parse(data);
              return Array.isArray(json) ? json : [];
            } catch {
              return [];
            }
          })();

      setServiceList(parsedData);
      setFilterList(parsedData);
    } catch (error) {
      console.error("Failed to fetch service list:", error);
      setServiceList([]);
      setFilterList([]);
    } finally {
        setLoading(false);
    }
  };

  fetchServiceList();
}, []);




    const handleFilterList = (event) => {
        const searchValue = event.target.value.toLowerCase();
        applyFilters(searchValue, filters.date, filters.category, filters.brand);
    };

    const handleFilterChange = (name, value) => {
        const newFilters = {
            ...filters,
            [name]: value
        };
        setFilters(newFilters);
        applyFilters('', newFilters.date, newFilters.category, newFilters.brand);
    };

    const applyFilters = (searchValue = '', dateFilter = '', categoryFilter = '', brandFilter = '') => {
        const newData = filterList.filter(list => {
            // Search filter
            const idMatch = list.service_id?.toString().toLowerCase().includes(searchValue);
            const categoryMatch = list.category_name ? list.category_name.toLowerCase().includes(searchValue) : false;
            const brandMatch = list.brand ? list.brand.toLowerCase().includes(searchValue) : false;
            const searchMatch = idMatch || categoryMatch || brandMatch;

            // Date filter (assuming you have a date field in your data)
            const dateMatch = dateFilter ? list.created_at?.includes(dateFilter) : true;

            // Category filter
            const categoryFilterMatch = categoryFilter ?
                list.category_name?.toLowerCase().includes(categoryFilter.toLowerCase()) : true;

            // Brand filter
            const brandFilterMatch = brandFilter ?
                list.brand?.toLowerCase().includes(brandFilter.toLowerCase()) : true;

            return searchMatch && dateMatch && categoryFilterMatch && brandFilterMatch;
        });
        setServiceList(newData);
    };

    const resetFilters = () => {
        setFilters({
            date: '',
            category: '',
            brand: ''
        });
        setServiceList(filterList);
    };

    const handleTableChange = (pagination) => {
        setPagination(pagination);
    }

    return (
        <div>
            <div className={styles.filterContainer}>
                <div className={styles.searchWrapper}>
                    <div className={styles.input_wrapper}>
                        <FaSearch className={styles.search_icon} />
                        <input
                            placeholder='Search here'
                            onChange={handleFilterList}
                            className={styles.input_search}
                        />
                    </div>
                </div>

                <div className={styles.filterWrapper}>
                    <button
                        className={styles.filterToggle}
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <FaFilter /> {showFilters ? 'Hide Filters' : 'Show Filters'}
                    </button>

                    {showFilters && (
                        <div className={styles.filterDropdown}>
                            <div className={styles.filterGroup}>
                                <label>Date:</label>
                                <input
                                    type="date"
                                    value={filters.date}
                                    onChange={(e) => handleFilterChange('date', e.target.value)}
                                    className={styles.filterInput}
                                />
                            </div>

                            <div className={styles.filterGroup}>
                                <label>Category:</label>
                                <input
                                    type="text"
                                    placeholder="Enter category"
                                    value={filters.category}
                                    onChange={(e) => handleFilterChange('category', e.target.value)}
                                    className={styles.filterInput}
                                />
                            </div>

                            <div className={styles.filterGroup}>
                                <label>Brand:</label>
                                <input
                                    type="text"
                                    placeholder="Enter brand"
                                    value={filters.brand}
                                    onChange={(e) => handleFilterChange('brand', e.target.value)}
                                    className={styles.filterInput}
                                />
                            </div>

                            <button
                                className={styles.resetButton}
                                onClick={resetFilters}
                            >
                                Reset Filters
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <div className={styles.service_container}>
                <Table
                    title={() => (
                        <div className={styles.tableTitle}> Service List </div>
                    )}
                    columns={columns.map((col) => ({
                        ...col,
                        onHeaderCell: () => ({
                            style: {
                                background: 'linear-gradient(135deg, #f0f9ff 0%, #e6f7ff 100%)',
                                fontWeight: 'bold',
                                fontSize: '18px',
                                padding: '20px',
                                textAlign: 'center',
                                maxWidth: '200px',
                                minWidth: '150px',
                                height: '100px',
                            },
                        }),
                        onCell: () => ({
                            style: {
                                textAlign: 'center',
                                padding: '20px',
                                fontSize: '18px',
                                maxHeight: '150px',
                                height: '100px',
                                minWidth: '100px'
                            },
                        }),
                    }))}
                    dataSource={serviceList}

                      // 🔹 Show loading spinner inside the table
            loading={{
              spinning: loading, // your state variable
              tip: 'Loading list...',
              size: 'large',
            }}

            // 🔹 Hide “No Data” text while loading
            locale={{
              emptyText: loading ? '' : 'No order details to display',
            }}

                    scroll={{ x: true }}
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        defaultPageSize: 10,
                      }}
                    className={styles.orderTable}
                    onChange={handleTableChange}
                />
            </div>
        </div>
    );
};

export default ServiceList;